import React, { useState } from 'react';
import { Card, Typography, Flex, Row, Col, Empty, Space, Divider, Select, Input, Upload, Button, Table, Tag, Form, message } from 'antd';
import { CloudDownloadOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';

const { Title, Text, Paragraph } = Typography;

const UserTicketModal = ({ ticket, selectedOption }) => {

    const fileList = ticket?.issue_files || [];

    const getFileIcon = (fileName) => {
        const ext = fileName?.split('.').pop().toLowerCase();
        const icons = {
            pdf: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png',
            doc: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png',
            docx: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png',
            jpg: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png',
            jpeg: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png',
            png: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp',
            zip: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png',
            ppt: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png',
            pptx: 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png',
        };
        return icons[ext] || 'https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg';
    };

    const generateTableData = (item) => [
        {
            key: '1',
            field: 'Action Details',
            value: item.action_details ? item.action_details : "N/A"
        },
        {
            key: '2',
            field: 'Action On',
            value: item.action_on ? moment(item.action_on).local().format("DD-MM-YYYY hh:mm A") : 'N/A',
        },
        selectedOption === "all-ticket" ? {
            key: '3',
            field: 'Action By',
            value: item.assigned_to ? item.assigned_to : "N/A",
        } : null,
    ];

    const columns = [
        {
            title: 'Field',
            dataIndex: 'field',
            key: 'field',
            width: '40%',
            render: (text) => <div strong>{text}</div>,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            width: '60%',
        },
    ];

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Flex justify="space-between" align="center">
                <Title level={5} style={{ margin: 0 }}>{ticket?.subject || 'Ticket Title'}</Title>
                <Tag color={ticket?.status === 'Open' ? 'red' : ticket?.status === 'Closed' ? 'green' : ticket?.status === 'In Progress' ? 'yellow' : 'gray'}>{ticket?.status || 'Pending'}</Tag>
            </Flex>

            <Paragraph style={{ margin: "0px", marginTop: "-10px" }}>{ticket?.description || 'No description provided.'}</Paragraph>
            {fileList && fileList?.length > 0 &&
                <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                    {fileList?.map((item, index) => (
                        <Col xs={24} sm={8} key={index}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #D3D3D3",
                                    padding: "10px",
                                    borderRadius: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        height: "40px",
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img
                                        style={{ height: "50px", width: "50px" }}
                                        src={getFileIcon(item?.file_name)}
                                        alt="file-icon"
                                    />
                                </div>
                                <div style={{ flex: 1, marginLeft: "10px" }}>
                                    <div
                                        className="field-label"
                                        style={{ fontWeight: "normal", wordBreak: "break-all" }}
                                    >
                                        {item?.file_name
                                            ? item?.file_name.length <= 13
                                                ? item?.file_name
                                                : `${item?.file_name.slice(0, 13)}.${item?.file_name.split(".").pop()}`
                                            : "No file name"}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            gap: "20px",
                                            marginTop: "5px",
                                            color: "gray",
                                        }}
                                    >
                                        <div>{(item?.file_size / 100).toFixed(2)} KB</div>
                                        <div>
                                            <a
                                                href={item?.file_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <CloudDownloadOutlined style={{ fontSize: "19px", color: "gray" }} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            }

            <Divider orientation="left">Progress Note for this Ticket</Divider>
            <Table
                columns={columns}
                dataSource={generateTableData(ticket)}
                pagination={false}
                showHeader={false}
                size="small"
                bordered
            />

            {ticket?.action_files && ticket?.action_files?.length > 0 &&
                <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                    {ticket?.action_files?.map((item, index) => (
                        <Col xs={24} sm={8} key={index}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #D3D3D3",
                                    padding: "10px",
                                    borderRadius: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        height: "40px",
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img
                                        style={{ height: "50px", width: "50px" }}
                                        src={getFileIcon(item?.file_name)}
                                        alt="file-icon"
                                    />
                                </div>
                                <div style={{ flex: 1, marginLeft: "10px" }}>
                                    <div
                                        className="field-label"
                                        style={{ fontWeight: "normal", wordBreak: "break-all" }}
                                    >
                                        {item?.file_name
                                            ? item?.file_name.length <= 13
                                                ? item?.file_name
                                                : `${item?.file_name.slice(0, 13)}.${item?.file_name.split(".").pop()}`
                                            : "No file name"}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            gap: "20px",
                                            marginTop: "5px",
                                            color: "gray",
                                        }}
                                    >
                                        <div>{(item?.file_size / 100).toFixed(2)} KB</div>
                                        <div>
                                            <a
                                                href={item?.file_url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <CloudDownloadOutlined style={{ fontSize: "19px", color: "gray" }} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            }

        </Space >
    );
};

export default UserTicketModal;
